import React from 'react';

const TrialExpirationBanner = ({ subscriptionStatus, onUpgradeClick, isDarkMode }) => {
  if (!subscriptionStatus) return null;

  const { status, trial_end } = subscriptionStatus;
  
  // Only show banner for trial users
  if (status !== 'trialing') return null;

  // Calculate days remaining
  const trialEndDate = new Date(trial_end);
  const now = new Date();
  const daysRemaining = Math.ceil((trialEndDate - now) / (1000 * 60 * 60 * 24));

  // Determine banner color based on days remaining
  let bannerClass = 'bg-blue-50 border-blue-200';
  let textClass = 'text-blue-800';
  let iconColor = 'text-blue-600';
  
  if (daysRemaining <= 3) {
    bannerClass = 'bg-red-50 border-red-200';
    textClass = 'text-red-800';
    iconColor = 'text-red-600';
  } else if (daysRemaining <= 7) {
    bannerClass = 'bg-orange-50 border-orange-200';
    textClass = 'text-orange-800';
    iconColor = 'text-orange-600';
  }

  if (isDarkMode) {
    if (daysRemaining <= 3) {
      bannerClass = 'bg-red-900/20 border-red-700';
      textClass = 'text-red-200';
      iconColor = 'text-red-400';
    } else if (daysRemaining <= 7) {
      bannerClass = 'bg-orange-900/20 border-orange-700';
      textClass = 'text-orange-200';
      iconColor = 'text-orange-400';
    } else {
      bannerClass = 'bg-blue-900/20 border-blue-700';
      textClass = 'text-blue-200';
      iconColor = 'text-blue-400';
    }
  }

  return (
    <div className={`mb-6 p-4 border rounded-lg ${bannerClass}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <svg className={`w-6 h-6 ${iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p className={`font-semibold ${textClass}`}>
              {daysRemaining > 1 
                ? `${daysRemaining} days remaining in your free trial`
                : daysRemaining === 1
                ? 'Last day of your free trial!'
                : 'Your trial has ended'}
            </p>
            <p className={`text-sm ${textClass} opacity-80`}>
              Upgrade now to continue accessing all features
            </p>
          </div>
        </div>
        <button
          onClick={onUpgradeClick}
          className="px-4 py-2 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap"
        >
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default TrialExpirationBanner;
